import { FileDoneOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { Tabs, TabsProps } from 'antd';
import { DocumentActions, DocumentInfo } from 'components/DocumentsResearch';
import DocumentChanges from 'components/DocumentsResearch/DocumentChanges';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import classes from './Report.module.scss';

import { useAppDispatch, useAppSelector } from 'store/hook';
import { setViewType } from 'store/slices/dataDocumentsSlice';
import { setReportSegment } from 'store/slices/researchSlice';
import { setUserChoosen } from 'store/slices/dataUsersSlice';
import { setIsRSidebarCollapsed } from 'store/slices/windowStateSlice';


const renderTabBar: TabsProps['renderTabBar'] = (props, DefaultTabBar) => {
  return <DefaultTabBar {...props} style={{ display: 'none' }} />;
};

export default function Report() {
  const { reportSegment, reportDocumentID } = useAppSelector((state) => state.research);
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  
  useEffect(() => {
    dispatch(setViewType('Report'));
    dispatch(setReportSegment('info'));
    dispatch(setUserChoosen(null));
    dispatch(setIsRSidebarCollapsed({collapsed: true, entity: '', width: 0}));

    return () => {
      dispatch(setViewType('Table'));
    };
  }, [dispatch]);

  const tabsItems: TabsProps['items'] = [
    {
      label: (
        <div className={classes.tabs_tab}>
          <FileDoneOutlined /> {t('Report.tabs.info')}
        </div>
      ),
      key: 'info',
      children: <DocumentInfo />,
    },
    {
      label: (
        <div className={classes.tabs_tab}>
          <FileDoneOutlined /> {t('Report.tabs.changes')}
        </div>
      ),
      key: 'changes',
      children:  <DocumentChanges />,
    },
    {
      label: (
        <div className={classes.tabs_tab}>
          <UnorderedListOutlined /> {t('Report.tabs.action')}
        </div>
      ),
      key: 'actions',
      children: reportDocumentID && <DocumentActions document_id={reportDocumentID} />,
    },
  ];

  return (
    <div className={classes.wrapper}>
      <div className={classes.mainSpace}>
        <Tabs 
          items={tabsItems}
          activeKey={reportSegment}
          className={classes.tabs}
          renderTabBar={renderTabBar}
        />
       
      </div>
    </div>
  );
}
